module.exports = __webpack_public_path__ + "media/images/banner-fdb44ad01773c98c27dcbb6d621bdedd.jpg";